import { useState } from 'react';
import { useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';
import BlurText from '../../../components/effects/BlurText';

export default function AboutSection() {
  const copy = useMessages().home.about;
  const [activeIndex, setActiveIndex] = useState(1);
  const activeStep = copy.journey[activeIndex];

  return (
    <section id="about" className="statement">
      <div className="container statement-inner">
        <div className="statement-canvas">
          <FadeInOnScroll className="statement-copy">
            <h2>
              <BlurText text={copy.lines[0]} />
              <br />
              <BlurText text={copy.lines[1]} className="muted-heading" delay={130} />
            </h2>
            <p>{copy.description}</p>
          </FadeInOnScroll>
          <FadeInOnScroll className="statement-diagram" delay={100}>
            <svg
              className="statement-diagram__path"
              viewBox="0 0 1000 180"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <path
                className="statement-diagram__track"
                d="M120 105 C260 105 310 56 500 56 S740 105 880 105"
              />
              <path
                className="statement-diagram__beam"
                d="M120 105 C260 105 310 56 500 56 S740 105 880 105"
                pathLength="1000"
              />
            </svg>
            <div className="statement-diagram__nodes" role="group" aria-label={copy.journeyLabel}>
              {copy.journey.map((step, index) => (
                <button
                  className={`statement-node${activeIndex === index ? ' is-active' : ''}`}
                  key={step.title}
                  type="button"
                  aria-label={step.title}
                  aria-pressed={activeIndex === index}
                  onClick={() => setActiveIndex(index)}
                  onMouseEnter={() => setActiveIndex(index)}
                  onFocus={() => setActiveIndex(index)}
                >
                  <span className="statement-node__ring" aria-hidden="true">
                    <span className="statement-node__core" />
                  </span>
                  <span className="statement-node__label">{step.shortTitle ?? step.title}</span>
                </button>
              ))}
            </div>
          </FadeInOnScroll>
          <div className="statement-detail" aria-live="polite">
            <div key={activeStep.title} className="statement-detail__content">
              <h3>{activeStep.title}</h3>
              <p>{activeStep.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
